import Logger from "../../../../utils/Logger";

export const MODE_XML_HTTP_REQUEST = 0;
export const MODE_FETCH_STREAM = 1;

/**
 * Socket parent class
 */
export default class Socket {

    /**
     * @param {string} url to call
     */
    constructor(url) {
        this.url = url;
        this.httpRequest = new XMLHttpRequest();
        this.writer = null;
        this.signal = null;
        this.controller =  null;
        this.volume = 0;
        this.httpStatus = -1;
        this.hasFailed = false;
        this.mode = MODE_XML_HTTP_REQUEST;

        if (window["fetch"] && window["AbortController"] && window["WritableStream"] && window["ReadableStream"]) { // Pre requistes
            const ua = navigator.userAgent.toLowerCase();
            const versionArray = ua.substring(ua.indexOf("chrome")+7).split(".");
            if (ua.indexOf("chrome") > 0 && versionArray.length > 0 && parseInt(versionArray[0]) >= 42) { // README EWA-124 : Only supports Chrome 42+ currently
                //Logger.log("Using fetch stream socket mode (supported browser)");
                //this.mode = MODE_FETCH_STREAM;
            }
        }
    }

    /**
     * Call to start the socket transfer
     * /!\ DONT OVERRIDE THIS METHOD
     * @return {Promise}
     */
    run() {
        return new Promise((resolve) => {
            this.runInternal(this.httpRequest, resolve);
        });
    }

    /**
     * Call when socket should start its transfer
     * /!\ SHOULD BE OVERRIDEN BY SUBCLASS
     *
     * @param httpRequest
     * @param resolve
     */
    /*eslint-disable no-unused-vars*/
    runInternal(httpRequest, resolve) {
    }

    stop() {
        Logger.log("Aborting socket");
        if (this.mode === MODE_FETCH_STREAM) {
            this.writer.abort();
            this.controller.abort();
        } else if (this.mode === MODE_XML_HTTP_REQUEST) {
            this.httpRequest.abort();
        }
    }
}


// WEBPACK FOOTER //
// ./js/core/script/executors/mscore/socket/Socket.js